import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Sortable {
  sortByHeader$: Observable<string>;
  sortAscending$: Observable<boolean>;
}

@Component({
  selector: 'lohi-sort-indicator',
  templateUrl: './sort-indicator.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortIndicatorComponent implements OnInit, OnDestroy {
  private destroy$$ = new Subject();
  private headerName$$ = new BehaviorSubject<string>(null);
  public activeColumn$$ = new BehaviorSubject<boolean>(false);
  public reversed$$ = new BehaviorSubject<boolean>(false);

  @Input() public set activeColumn(bool: boolean) {
    this.activeColumn$$.next(bool);
  }
  @Input() public set reversed(bool: boolean) {
    this.reversed$$.next(bool);
  }
  @Input() public set sortingObservable(sortable: Sortable) {
    this.setupSortable(sortable);
  }
  @Input() public set headerName(name: string) {
    this.headerName$$.next(name);
  }

  constructor() {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  private setupSortable(sortable: Sortable) {
    this.destroy$$.next();

    sortable.sortAscending$.pipe(takeUntil(this.destroy$$)).subscribe((bool) => {
      this.reversed = !bool;
    });

    combineLatest([sortable.sortByHeader$, this.headerName$$])
      .pipe(takeUntil(this.destroy$$))
      .subscribe(([sortByHeader, headerName]) => {
        if (!headerName) {
          this.activeColumn$$.next(false);
        }
        this.activeColumn$$.next(sortByHeader === headerName);
      });
  }
}
